<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-80">
            <div class="media">
              <img src="/static/img/test@2x.png"/>
              <div class="media-body">
                <h1>{{examPaper.title}}</h1>
                <div>
                  <span class="gray">유형</span> {{examPaper.exam_paper_type_name}}
                    ·  <span class="gray">문제수 </span> <span class="number">{{examPaper.quiz_cnt}}</span>
                    ·  <span class="gray">카테고리</span> {{examPaper.cate_path}}
                  <span v-if="examPaper.curriculum_seq !== 0"> · <span class="gray">커리큘럼</span> {{`${examPaper.curriculum_name} (${examPaper.times})`}}</span>
                </div>
                <div>
                  <span class="gray">시험 내용</span> {{examPaper.content}}
                </div>
              </div>
            </div>
          </div>
          <div class="p-2 ml-auto button-group">
            <button type="button" class="btn btn-danger btn-dropdown" @click="handleCommand('delete')" v-if="this.$store.getters.user_id === 'ADMIN'">삭제</button>
            <!-- <button type="button" class="btn btn-info" @click="handleCommand('download')" v-if="examPaper.download_url_pdf">시험지</button>
            <button type="button" class="btn btn-secondary" @click="handleCommand('download_desc')" v-if="examPaper.download_url_desc_pdf">정답 및 해설</button> -->
            <el-dropdown @command="handleCommand">
              <el-button class="btn btn-info btn-white">
                시험지<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="paper_pdf">PDF</el-dropdown-item>
                <el-dropdown-item command="paper_hwp">HWP</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="handleCommand">
              <el-button class="btn btn-secondary btn-white">
                정답 및 해설<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="paper_desc_pdf">PDF</el-dropdown-item>
                <el-dropdown-item command="paper_desc_hwp">HWP</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2">
            <h2>문제 <span class="number mint">{{examPaper.quiz_cnt}}</span></h2>
          </div>
          <div class="ml-auto p-2">
          </div>
        </div>
      </div>

      <data-tables
        class="no-left-margin small-td item"
        :data="tableData"
        :table-props="quizProps"
        :page-size="emptyPageSize"
        :pagination-props="emptyPaginationProps"
        v-loading="searchLoading">

        <el-table-column label="내용" header-align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.grp_type === 'C'">
              <el-tag size="medium" type="danger" disable-transitions>{{scope.row.tag}}</el-tag>
              &nbsp;&nbsp;<span class="font-bold quiz-item" v-html="scope.row.title"></span>
            </template>
            <template v-else>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="scope.row.lvl === 2">└&nbsp;&nbsp;</span>
              <el-tag size="medium" type="primary" disable-transitions>{{scope.row.tag}}</el-tag>
              &nbsp;&nbsp;{{`${scope.row.display_no}. ${scope.row.title}`}}
              &nbsp;&nbsp;
              <router-link :to="{name: 'M030102', params: {quiz_seq: scope.row.quiz_seq, exam_paper_seq: scope.row.exam_paper_seq, page: 'M040102'}}">
                <el-tag size="medium" type="info" disable-transitions>문제 상세</el-tag>
              </router-link>
            </template>
          </template>
        </el-table-column>
      </data-tables>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2">
            <h2>출제된 시험 <span class="number mint">{{examTableData.length}}</span></h2>
          </div>
          <div class="ml-auto p-2">
          </div>
        </div>
      </div>

      <stone-data-table
        :loading="searchLoading"
        :columns="examTableColumns"
        :data="examTableData"
        :table-props="examTableProps"
        :pagination-props="examPaginationProps"
        :action-col="examActionCol">
      </stone-data-table>
    </div>

  </div>
</template>

<script>
import common from '@/modules/common'

export default {
  name: 'M040102',
  mixins: [common.mixins],
  data () {
    return {
      examPaper: {
        book_name: '',
        cate_code: '',
        cate_code_name: '',
        cate_path: '',
        content: '',
        curriculum_name: '',
        curriculum_seq: 0,
        download_url: '',
        download_url_desc: '',
        download_url_pdf: '',
        download_url_desc_pdf: '',
        exam_paper_seq: 0,
        exam_paper_type: '',
        exam_paper_type_name: '',
        exam_yn: '',
        file_name: '',
        file_name_pdf: '',
        file_pdf_seq: 0,
        file_seq: 0,
        ordby: 0,
        quiz_cnt: 0,
        times: 0,
        title: '',
        use_yn: 'Y'
      },
      tableData: [],
      searchDef: {show: false},
      quizProps: {showHeader: false, maxHeight: this.getScreenHeight()},
      quizColumns: [
        // {label: '분류', prop: 'grp_type_name', align: 'center'},
        {label: '구분', prop: 'tag', align: 'center'},
        {label: '내용', prop: 'title', align: 'left', width: 300}
        // {label: '정답률', prop: 'quiz_correct_rate', align: 'right', formatter: this.columnFormatterRate}
      ],
      examTableProps: {height: 285},
      examPaginationProps: {},
      examTableData: [],
      examActionCol: {
        label: ' ',
        props: {
          align: 'center',
          width: 100
        },
        buttons: [{
          handler: row => {
            this.$router.push({name: 'M050103', params: {exam_seq: row.exam_seq}})
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: '상세'
        }]
      }
    }
  },
  beforeCreate () {
  },
  created () {
    const examPaperSeq = this.$route.params.exam_paper_seq
    if (!this.isEmptySeq(examPaperSeq)) {
      this.loadInfo(examPaperSeq)
      this.loadPaperExam(examPaperSeq)
    } else {
      this.$router.push({name: 'M040101'})
    }
  },
  methods: {
    loadInfo (examPaperSeq) {
      this.loadStoneDataTable('/paper/' + examPaperSeq, null, false)
        .then(response => {
          const result = response.data
          // console.log(result)
          Object.keys(this.examPaper).forEach(key => {
            this.examPaper[key] = this.isEmpty(result.exam_paper[key]) ? '' : result.exam_paper[key]
          })
          this.tableData = result.exam_paper_quiz
          // console.log(this.examPaper)
        })
    },
    handleCommand (command) {
      if (command === 'download') {
        this.downloadFile(this.examPaper.download_url_pdf)
      } else if (command === 'download_desc') {
        this.downloadFile(this.examPaper.download_url_desc_pdf)
      } else if (command === 'delete') {
        this.deletePaper(this.$route.params.exam_paper_seq)
      } else if (command === 'paper_pdf') {
        this.downloadPaperFile(this.examPaper.download_url_pdf, '시험지')
      } else if (command === 'paper_hwp') {
        this.downloadPaperFile(this.getDownloadFileName(this.examPaper.download_url), '시험지')
      } else if (command === 'paper_desc_pdf') {
        this.downloadPaperFile(this.examPaper.download_url_desc_pdf, '정답 및 해설')
      } else if (command === 'paper_desc_hwp') {
        this.downloadPaperFile(this.getDownloadFileName(this.examPaper.download_url_desc, 'desc'), '정답 및 해설')
      }
    },
    getDownloadFileName (url, type = '') {
      let filename = this.examPaper.title
      if (type === 'desc') {
        filename += '_정답및해설'
      }
      return encodeURI(url + '/' + filename)
    },
    downloadPaperFile (url, msg) {
      if (url) {
        this.downloadFile(url)
      } else {
        this.$message.error(msg + ' 파일이 존재하지 않습니다.')
      }
    },
    // 출제 시험 조회
    loadPaperExam (examPaperSeq) {
      this.loadStoneDataTable('/paper/exam/' + examPaperSeq, {})
        .then(response => {
          this.examTableData = response.data
        })
    },
    deletePaper (examPaperSeq) {
      this.$confirm('시험지를 삭제 하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/paper', {data: {exam_paper_seq: examPaperSeq}})
          .then(response => {
            // console.log('response : ', response)
            const result = response.data
            if (result.status === 1) {
              this.$message('시험지가 삭제되었습니다.')
              setTimeout(() => {
                this.$router.push({name: 'M040101', params: {isSearch: true}})
              }, 1000)
            } else {
              this.$message.warning(result.message)
            }
          })
      }).catch(() => {})
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/M040102.vue